module.exports = __webpack_public_path__ + "img/delivery-zones.f8b3060f.jpeg";